import { canCreateVictime, canUpdateVictime } from 'src/helpers/victime';
import { Victime } from '@norma/shared/types/victime.type';
import { useAuthenticatedUser } from './auth.hooks';
import { useDisplayedOrganization } from './organization.hooks';

export const useCanUpdateVictime = (victime: Victime): boolean => {
  const user = useAuthenticatedUser();
  const { organization } = useDisplayedOrganization();
  if (!user) {
    return false;
  }
  return canUpdateVictime(user, victime, organization ?? undefined);
};
export const useCanCreateVictime = (): boolean => {
  const user = useAuthenticatedUser();
  const { organization } = useDisplayedOrganization();
  if (!user) {
    return false;
  }
  return canCreateVictime(user, organization ?? undefined);
};
